import React from 'react';

const NotFound = () => (
  <h1>Sorry! Content currently not supported on your planet</h1>
)

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound.jsx